module.exports = __webpack_public_path__ + "static/media/CabinetChip_Before.8f4a016f.jpg";